import React from "react";
import { Link } from "react-router-dom";
import { ajax } from "../components/globals";
import { isPasswordValid } from "../auth/passwordPolicy";
import { UIInput, UIButton, UIConfirmPopup, PasswordPolicyTooltip } from "../components/guiElements";
import { Languages } from "../components/languages";

export default class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);

        this.le = Languages.PasswordRecovery[Languages.selectedLanguage];

        this.state = {
            token: params.get("token") || "",
            password: "",
            confirmPassword: "",
            passwordFocused: false,
            loading: false,
            successPopupOpen: false,
            error: ""
        };

        window.history.replaceState( {}, document.title, "/reset-password" );
    }

    goToLogin = () => {
        this.props.history.replace("/");
    };

    keyUp = event => {
        if ( event.key === "Enter" &&  !this.state.loading
        ) {
            this.submit();
        }
    };

    submit = () => {
        if (this.state.loading) {
            return;
        }

        if (!this.state.token) {
            this.setState({
                error: this.le.common.invalidLink
            });
            return;
        }

        if (!isPasswordValid(this.state.password)) {
            this.setState({
                error: this.le.reset.requirementsError
            });
            return;
        }

        if (this.state.password !== this.state.confirmPassword
        ) {
            this.setState({
                error: this.le.reset.mismatchError
            });
            return;
        }

        this.setState({
            loading: true,
            passwordFocused: false,
            error: ""
        });

        ajax(
            this,
            {
                method: "post",
                url: "/api/user/password-reset/confirm",
                data: {
                    token: this.state.token,
                    password: this.state.password,
                    confirmPassword: this.state.confirmPassword
                }
            },
            () => {
                this.setState({
                    token: "",
                    password: "",
                    confirmPassword: "",
                    passwordFocused: false,
                    loading: false,
                    successPopupOpen: true,
                    error: ""
                });
            },
            () => {
                this.setState({
                    passwordFocused: false,
                    loading: false,
                    successPopupOpen: false,
                    error: this.le.reset.invalidOrExpired
                });
            }
        );
    };

    render() {

        return (
            <div className="full-panel page-password-recovery page-reset-password">
                <div className="page-login">
                    <div className={"widget " + (this.state.loading ? "disabled" : "")}>
                        <div className="widget-header">
                            <div className="login-header-logo" />
                        </div>
                        <div className="widget-content">
                            <div className="widget-content-title">
                                {this.le.reset.title}
                            </div>

                            <div
                                className="password-input-container"
                                onFocus={() =>
                                    this.setState({
                                        passwordFocused: true
                                    })
                                }
                                onBlur={event => {
                                    const focusRemainsInside = event.currentTarget.contains(event.relatedTarget);

                                    if (!focusRemainsInside) {
                                        this.setState({
                                            passwordFocused: false
                                        });
                                    }
                                }}
                            >
                                <UIInput
                                    type="password"
                                    name="password"
                                    value={this.state.password}
                                    hint={ this.le.reset.passwordPlaceholder}
                                    maxLength={64}
                                    onKeyUp={this.keyUp}
                                    onChange={event =>
                                        this.setState({
                                            password: event.target.value,
                                            error: ""
                                        })
                                    }
                                /> 

                                {
                                    this.state.passwordFocused &&
                                    <PasswordPolicyTooltip
                                        id={ "reset-password-policy-tooltip" }
                                        password={ this.state.password }
                                    />
                                }
                            </div>

                            <UIInput
                                type="password"
                                name="confirmPassword"
                                value={this.state.confirmPassword}
                                hint={this.le.reset.confirmPasswordPlaceholder}
                                maxLength={64}
                                onKeyUp={this.keyUp}
                                onChange={event =>
                                    this.setState({
                                        confirmPassword: event.target.value,
                                        error: ""
                                    })
                                }
                            />

                            <UIButton
                                className="confirm slim"
                                text={this.le.reset.submit}
                                disabled={this.state.loading}
                                onClick={this.submit}
                            />

                            {
                                this.state.error &&
                                <div
                                    className="login-error"
                                    role="alert"
                                >
                                    {this.state.error}
                                </div>
                            }

                            <Link
                                className={"forgot-password-link"}
                                to="/"
                            >
                                {this.le.common.backToLogin}
                            </Link>
                        </div>
                    </div>
                </div>
                {
                    this.state.successPopupOpen &&
                    <UIConfirmPopup
                        title={ this.le.reset.successTitle}
                        message={this.le.reset.success}
                        confirmText={this.le.common.backToLogin}
                        icon={"fa-solid fa-circle-check"}
                        showCancelButton={false}
                        closeOnEscape={false}
                        closeOnOverlay={false}
                        autoFocusConfirm={true}
                        loading={false}
                        onConfirm={this.goToLogin}
                    />
                }
            </div>
        );
    }
}